/**
 * Returns a reference to webShellClient locale data get method from the web-shell-client's global web API.
 * Encapsulating this functionality allows much easier testing and necessary mocking as well as reuse if needed.
 *
 * @private
 * @returns {Object} webShellClientLocale Locale data
 * @returns {string} webShellClientLocale.country
 * @returns {string} webShellClientLocale.hreflang
 * @returns {string} webShellClientLocale.intl
 * @returns {string} webShellClientLocale.langRegion
 * @returns {string} webShellClientLocale.language
 * @returns {string} webShellClientLocale.urlParam
 * @returns {string} webShellClientLocale.cloudUrlFragment
 * @returns {string} webShellClientLocale.currency
 * @returns {string} webShellClientLocale.currencySymbol
 * @returns {string} webShellClientLocale.translationsLanguage
 * @returns {Object} webShellClientLocale.countryNames
 * @returns {string} webShellClientLocale.marketplaceId
 */

var getWebShellClientLocale = function getWebShellClientLocale() {
  var _window;
  return ((_window = window) === null || _window === void 0 || (_window = _window.webShellClient) === null || _window === void 0 || (_window = _window.locale) === null || _window === void 0 ? void 0 : _window.get()) || {};
};
export default getWebShellClientLocale;